import { MatSnackBar } from '@angular/material';
import { NotificationComponent } from '../notification/notification.component';
import * as i0 from "@angular/core";
import * as i1 from "@angular/material/snack-bar";
var NotificationService = /** @class */ (function () {
    function NotificationService(snackBar) {
        this.snackBar = snackBar;
    }
    NotificationService.prototype.showError = function (errorMessages) {
        this.snackBar.openFromComponent(NotificationComponent, {
            data: errorMessages
        });
    };
    NotificationService.prototype.showInfo = function (infoMessage) {
        this.snackBar.open(infoMessage, 'OK', { duration: 2000 });
    };
    NotificationService.ngInjectableDef = i0.defineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(i0.inject(i1.MatSnackBar)); }, token: NotificationService, providedIn: "root" });
    return NotificationService;
}());
export { NotificationService };
